import { render, staticRenderFns } from "./dialog-add-supplier.vue?vue&type=template&id=b251888a&scoped=true&"
import script from "./dialog-add-supplier.vue?vue&type=script&lang=js&"
export * from "./dialog-add-supplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b251888a",
  null
  
)

export default component.exports